export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.emdpay.emdpay&hl=en_IN";

// All images now served from /public/images/ so they get bundled into the build
// and hosted on YOUR server (no external dependency on Emergent CDN).
const IMG = process.env.PUBLIC_URL + "/images";

export const LOGO_URL = `${IMG}/logo.png`;
export const LOGO_ICON_URL = `${IMG}/logo.png`;

export const APP_SCREENSHOTS = {
  home: `${IMG}/app-home.png`,
  educationFeePayment: `${IMG}/app-education-fee.png`,
  verifiedEducators: `${IMG}/app-verified.png`,
  flights: `${IMG}/app-flights.png`,
  hotels: `${IMG}/app-hotels.png`,
  buses: `${IMG}/app-buses.png`,
};

export const APP_BADGES_IMAGE = `${IMG}/app-store-badges.png`;

// Section images (Education & Professional stock photos)
export const EDUCATION_IMAGE = `${IMG}/education.jpg`;
export const PROFESSIONAL_IMAGE = `${IMG}/professional.jpg`;

export const SUPPORT_EMAIL = "support@emdpay.in";
export const COMPANY = "RIGARO EWORKS LLP";
